import getMapData from './_getMapData';

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

export default mapCacheSet;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_mapCacheSet.js
// module id = 323
// module chunks = 0